import { Container } from "react-bootstrap";
import DriverStats from "../../components/driveActivity/DriverStats";
import DriverFilters from "../../components/driveActivity/DriverFilters";
import DriverCharts from "../../components/driveActivity/DriverCharts";
import DriverTable from "./DriverTable";
import { Loader } from "../../components/common/Loader";
import { bookingsAnalyticsApi, getDriverActivityDetailList } from "../../services/Networkcall";
import { useCallback, useEffect, useState } from "react";
import { errorAlert } from "../../components/common/Alert";

export default function DriverActivityPage() {
  const [loading, setLoading] = useState(false);
  const [analyticsData, setAnalyticsData] = useState(null);
  const [driverData, setDriverData] = useState(null);
  const [filters, setFilters] = useState({ search: '', status: 'All', locationId: '', driver: '' });
  const [debouncedSearch, setDebouncedSearch] = useState(filters.search);
  const [pagination, setPagination] = useState({
    page: 1,
    totalPages: 1,
    limit: 5,
    totalItems: 0,
    totalRecords: 0
  });

  useEffect(() => {
    const handler = setTimeout(() => {
      if (filters.driver) {
        setDebouncedSearch(filters.driver);
      } else {
        setDebouncedSearch(filters.search);
      }
    }, 500); // Adjust the debounce delay as needed (500ms in this case)

    return () => {
      clearTimeout(handler);
    };
  }, [filters.search, filters.driver]);

  const fetchDriverActivityAnalytics = async () => {
    setLoading(true);
    try {
      const res = await bookingsAnalyticsApi();
      if (res?.success) {
        setAnalyticsData(res?.data || null);
      } else {
        errorAlert({ message: res?.message || "Failed to fetch analytics data" });
      }
    } catch (err) {
      errorAlert({ message: err?.response?.data?.message || err?.message || "Failed to fetch analytics data" });
    } finally {
      setLoading(false);
    }
  };

  const fetchDriverActivityDetailList = async () => {
    setLoading(true);
    const payload = {
      page: pagination.page,
      limit: pagination.limit,
      search: debouncedSearch,
      status: filters.status === "All" ? '' : filters.status,
      locationId: filters?.locationId || '',
    }
    try {
      const res = await getDriverActivityDetailList(payload);
      if (res?.success) {
        setDriverData(res?.data || null);
        setPagination({ page: res?.currentPage, totalPages: res?.totalPages, totalRecords: res?.totalRecords });
      } else {
        errorAlert({ message: res?.message || "Failed to fetch driver data" });
      }
    } catch (err) {
      errorAlert({ message: err?.response?.data?.message || err?.message || "Failed to fetch analytics data" });
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    fetchDriverActivityAnalytics();
  }, []);

  useEffect(() => {
    fetchDriverActivityDetailList();
  }, [debouncedSearch, pagination.page, filters.status, filters.locationId]);

  const pageHandler = useCallback((page) => {
    setPagination((prev) => ({ ...prev, page }));
  }, []);

  return (

    <Container fluid className="da-page vh-100 overflow-scroll">
      <Loader show={loading} />

      {/* HEADER */}
      <div className="da-header">
        <div>
          <h3>Driver Activity</h3>
          <p>View driver performance and booking activity.</p>
        </div>

        {/* <div className="da-actions">
          <button className="date-btn">04/17/2025 - 04/24/2025</button>
          <button className="filter-btn">Filters</button>
        </div> */}
      </div>

      {/* STATS */}
      <DriverStats analyticsData={analyticsData} />

      {/* FILTERS */}
      <DriverFilters filters={filters} setFilters={setFilters} />

      {/* TABLE */}
      <DriverTable data={driverData} pagination={pagination} pagehandler={pageHandler} />

      {/* CHARTS */}
      <DriverCharts />

    </Container>
  );
}